import ExternalIDP from './model.js'
import { deepGet, addToCollection } from '../shared/helper'

export default {
  namespaced: true,
  state: {
    externalIDP: [],
    filteredCollection: [],
    customerCollection: [],
    accountCollection: [],
    types: [],
    currentExternalIDP: new ExternalIDP(),
    currentCustomer: null,
  },
  getters: {
    getExternalIDPCollection: state => state.externalIDP,
    getFilteredCollection: state => state.filteredCollection,
    getById: state => (id) => state.externalIDP.find(idp => idp.id === id),
    getCurrentExternalIDP: state => state.currentExternalIDP,
    getCustomerCollection: state => state.customerCollection,
    getAccountCollection: state => state.accountCollection,
    getCurrentCustomer: state => state.currentCustomer,
    getTypes: state => state.types,
  },
  actions: {
    getExternalIDPCollection({ commit, getters, state }, payload) {
      return this.dispatch('get', {
        path: 'v1/externalIdps',
        ...payload
      }).then((res) => {

        const data = deepGet(res, 'body.data')
        if (data) {

          const models = data.map((idp) => {
            commit('addExternalIDPToCollection', { externalIDPData: idp })
            return getters.getById(idp.id)
          })

          commit('addExternalIDPToFilteredCollection', models)

          return { data: models, meta: res.body.meta }
        }
        return res
      })
    },
    verifyExternalIDPExists({ commit, getters, state }, payload) {
      return this.dispatch('get', {
        path: 'v1/externalIdps',
        ...payload
      }).then((res) => {

        const data = deepGet(res, 'body.data')
        if (data) {
          return { data, meta: res.body.meta }
        }
        return res
      })
    },
    getCustomerCollection({ commit }, payload) {
      const id = payload.id
      delete payload.id
      return this.dispatch('get', {
        path: 'v1/externalIdps/' + id + '/customers',
        ...payload
      }).then((res) => {
        commit('updateCustomerCollection', res && res.body)
        return res && res.body
      })
    },
    getAccountCollection({ state, commit }, payload) {
      if (!state.currentCustomer) {
        throw Error('missing current customer')
      }
      const id = payload.id
      delete payload.id
      return this.dispatch('get', {
        path: `v1/externalIdps/${id}/customers/${state.currentCustomer.id}/accounts`,
        ...payload
      }).then((res) => {
        commit('updateAccountCollection', res && res.body)
        return res && res.body
      })
    },
    create({ commit, getters }, data) {
      return this.dispatch('post', {
        path: 'v1/externalIdps',
        data: data
      }).then((res) => {

        commit('addExternalIDPToCollection', { externalIDPData: res.body && res.body.data })

        return getters.getById(res.body && res.body.data.id)
      })
    },
    updateExternalIDP({ commit, getters }, model) {
      return this.dispatch('put', {
        path: 'v1/externalIdps/' + model.id,
        data: model.getJSON()
      }).then((res) => {

        commit('addExternalIDPToCollection', { externalIDPData: res.body && res.body.data })

        return getters.getById(res.body && res.body.data.id)
      })
    },
    updateCustomerAccount({ state }, payload) {
      if (!state.currentCustomer) {
        throw Error('missing current customer')
      }
      return this.dispatch('put', {
        path: `v1/externalIdps/${payload.id}/customers/${state.currentCustomer.id}/accounts`,
        data: payload
      })
    },
    deleteExternalIDP({ commit }, payload) {
      return this.dispatch('del', {
        path: 'v1/externalIdps/' + payload.id
      }).then((res) => {

        commit('removeExternalIDPFromCollection', payload.id)

        return res
      })
    },
    getExternalIDPTypes({ commit }) {
      return this.dispatch('get', {
        path: 'v1/externalIdpTypes'
      }).then((res) => {
        res.body.data.forEach((type) => {
          commit('addExternalIDPTypeToCollection', type)
        })
        return res.body
      })
    }
  },
  mutations: {
    addExternalIDPToCollection(state, { externalIDPData, opts }) {
      addToCollection(this, state.externalIDP, externalIDPData, ExternalIDP, opts)
    },
    addExternalIDPToFilteredCollection(state, data) {
      state.filteredCollection = state.filteredCollection.concat(data)
    },
    removeExternalIDPFromCollection(state, externalIDPId) {
      const index = state.externalIDP.findIndex(el => el.id === externalIDPId)

      if (index === -1) {
        console.warn(`Could not find/delete external IDP ${externalIDPId}`)
        return
      }

      state.externalIDP.splice(index, 1)
    },
    addUsageToCollection(state, usageData) {
      addToCollection(this, state.usage, usageData, null, null)
    },
    addExternalIDPTypeToCollection(state, typeData) {
      addToCollection(this, state.types, typeData, null, null)
    },
    clearCollection(state) {
      state.externalIDP = []
    },
    clearFilteredCollection(state) {
      state.filteredCollection = []
    },
    clearCustomerCollection(state) {
      state.customerCollection = []
    },
    clearAccountCollection(state) {
      state.accountCollection = []
    },
    clearTypes(state) {
      state.types = []
    },
    updateAccountCollection (state, account) {
      state.accountCollection = state.accountCollection.concat(account.data)
    },
    updateCustomerCollection (state, customers) {
      state.customerCollection = state.customerCollection.concat(customers.data)
    },
    setCurrentExternalIDP (state, idp) {
      state.currentExternalIDP = idp
    },
    setCurrentCustomer (state, customer) {
      state.currentCustomer = customer
    },
    resetCurrentExternalIDP (state) {
      state.currentExternalIDP = new ExternalIDP()
    },
    resetCurrentCustomer (state) {
      state.currentCustomer = null
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/externalIDP/store.js